import { useEffect, useState } from 'react';
import { useSettings } from '../context/SettingsContext';
import { getSiteSettings } from '../services/siteSettingsService';

export default function useSiteSettings() {
  const context = useSettings();
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (context) return undefined;

    let mounted = true;
    getSiteSettings()
      .then((data) => {
        if (mounted) setSettings(data);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [context]);

  if (context) {
    return { settings: context.siteSettings, loading: context.loading };
  }

  return { settings, loading };
}
